<div class="page-body">
  <div *ngIf="!loading && error" class="error-wrapper">
    <div class="contents-container">
      <p class="heading">Noe gikk galt.</p>
      <p class="info-text">
        Prøv å laste inn siden på nytt ellers prøv igjen senere.
      </p>

      <div class="button-wrapper">
        <zaver-secondary-button-outlined
          class="error-button"
          text="Tilbake"
          (click)="handleCancellation()"
          [rounded]="true"
          [disabled]="navigationInProgress"
        ></zaver-secondary-button-outlined>
      </div>
    </div>
  </div>

  <div *ngIf="loading && !error">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !error">
    <div class="banner">
      <button type="button" class="back-button" (click)="handleCancellation()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span class="back-text">Tilbake</span>
      </button>
    </div>

    <div *ngIf="kalpAnswers" class="contents-wrapper">
      <div class="contents-container">
        <app-leq-summary-no
          class="leq-summary"
          [kalpAnswers]="kalpAnswers"
        ></app-leq-summary-no>

        <div class="footer-container">
          <zaver-basic-button
            class="update-button"
            text="Endre svar"
            [secondary]="true"
            [md]="true"
            [disabled]="navigationInProgress"
            (click)="handleUpdateClick()"
          >
          </zaver-basic-button>

          <zaver-basic-button
            text="Neste"
            [primary]="true"
            [md]="true"
            [disabled]="navigationInProgress"
            (click)="handleCtaClickReview()"
          >
          </zaver-basic-button>
        </div>
      </div>
    </div>
  </div>
</div>
